import { useTranslation } from 'react-i18next';
import { Badge } from '@components/badge';
import { BADGE_VARIANT_BLUE_SOFT } from '@components/badge/badge.type';
import classNames from 'classnames';
import { Command } from 'cmdk';

import { MAGIC_SEARCH_ITEM_CLASS } from '../constants';
import { MagicSearchVenueCompanyItemProps } from '../magic-search-palette.type';
import { getVenueRoute } from '../utils/get-venue-route';

export const MagicSearchVenueCompanyItem = ({ venue, company, onOpen }: MagicSearchVenueCompanyItemProps) => {
  const { t } = useTranslation();

  return (
    <Command.Item
      value={`venue:${venue.id}:${company.id}`}
      onSelect={() => onOpen(getVenueRoute(venue, company))}
      aria-label={`Open ${venue.name} as ${company.name}`}
      className={classNames(MAGIC_SEARCH_ITEM_CLASS, 'py-1.5')}
      data-testid={`magic-search--result-venue-${venue.id}-${company.id}`}>
      <span className='flex min-w-0 flex-1 items-baseline gap-2 text-body-s'>
        <span className='shrink-0 text-tertiary'>{t('menu:magicSearchOpenAs')}</span>
        <span className='truncate text-subtitle-s text-primary' data-testid='magic-search-venue--company-name'>
          {company.name}
        </span>
        <span className='shrink-0 text-body-xs text-tertiary'>#{company.legacyId}</span>
      </span>
      {company.isOwner && (
        <Badge variant={BADGE_VARIANT_BLUE_SOFT} dataTestId='magic-search-venue--owner'>
          {t('companySettings:venuesOwnerTag')}
        </Badge>
      )}
    </Command.Item>
  );
};
